import { ReactNode, useCallback, useState } from 'react';
import { SnackbarProps, SnackbarStatus, useSnackbar } from '@weareopenr/component-library';

export const useModalNotification = () => {
  const { showSnackbar } = useSnackbar();
  const [errorMessage, setErrorMessage] = useState<string | ReactNode | null>(null);

  const showNotification = useCallback(
    (snackbar: SnackbarProps) => {
      snackbar.status === SnackbarStatus.ERROR ? setErrorMessage(snackbar.message) : showSnackbar(snackbar);
    },
    [showSnackbar],
  );

  const clearError = useCallback(() => setErrorMessage(null), []);

  return { errorMessage, showNotification, clearError } as const;
};
